export default __webpack_public_path__ + "static/bje-baustellenplaner-01-um-d5622adcef7fac25a1c53756248e1fbc.jpg";